import script from "./AttachmentsAnalytics.vue?vue&type=script&setup=true&lang=js"
export * from "./AttachmentsAnalytics.vue?vue&type=script&setup=true&lang=js"

import "./AttachmentsAnalytics.vue?vue&type=style&index=0&id=77dce54a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77dce54a"]])

export default __exports__